/* eslint-disable import/no-named-as-default-member */
import { initReactI18next } from "react-i18next";

import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import enTranslations from "./locales/english/en.json";
import myTranslations from "./locales/malay/my.json";

// Using void operator to explicitly mark the Promise as intentionally not awaited
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: enTranslations },
      my: { translation: myTranslations },
    },
    lng: "en",
    fallbackLng: "en",
    interpolation: {
      escapeValue: false,
    },
  })
  .catch((err) => {
    console.error("Error initializing i18n:", err);
  });

export default i18n;
